import cogoToast from 'cogo-toast';
import { TFunction } from 'react-i18next';

interface MaatwerkErrorDetails {
  title?: string;
  message?: string;
  jobResult?: unknown;
  // Legacy error format properties
  detail?: string;
  error?: string;
}

/**
 * Shows a toast error for maatwerk request failures
 * Attempts to parse error messages from API responses and job results
 * @param err The error object or string
 * @param t Translation function
 */
export const showMaatwerkErrorToast = (err: unknown, t: TFunction): void => {
  const errorMessage = err instanceof Error ? err.message : String(err);

  // Try to parse structured error details first
  try {
    const parsedError = JSON.parse(errorMessage) as MaatwerkErrorDetails;

    // Check if this is our new structured error format with title and message
    if (parsedError.title || parsedError.message) {
      const title =
        parsedError.title || t('FLOWS_PRODUCTS_MAATWERK_REQUEST_ERROR_GENERIC');
      const message = parsedError.message || t('FLOWS_ANVA_UNKNOWN_ERROR');

      // Show toast with title as heading and message as body
      cogoToast.error(message, {
        hideAfter: 8,
        heading: title,
      });
      return;
    }

    // Fall back to legacy error format (detail/error fields)
    if (parsedError.detail || parsedError.error) {
      cogoToast.error(
        t('FLOWS_PRODUCTS_MAATWERK_REQUEST_ERROR', {
          error: parsedError.detail || parsedError.error || 'Unknown error',
        }),
      );
      return;
    }
  } catch {
    // JSON parsing failed, fall through to default handling
  }

  // Default fallback for unparseable errors
  cogoToast.error(t('FLOWS_PRODUCTS_MAATWERK_REQUEST_ERROR_GENERIC'));
};
